enum SalesSystemEnum {
	isell = 'isell',
	bitboxer = 'bitboxer',
	navision = 'navision',
	other = 'other'
}

export default SalesSystemEnum;
